import { NotificationResponse } from '../types/notifications';
import { getApiUrl } from './api.config';

export const notificationApi = {
  // Get all notifications for the current user
  async getNotifications(userEmail: string): Promise<NotificationResponse> {
    const token = localStorage.getItem('authToken');
    if (!token) throw new Error('Not authenticated');
    
    const response = await fetch(getApiUrl(`notifications?userEmail=${encodeURIComponent(userEmail)}`), {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`Failed to fetch notifications: ${response.status}`);
    }
    
    return response.json();
  },

  // Mark notification as read
  async markAsRead(notificationId: number, userEmail: string): Promise<void> {
    const token = localStorage.getItem('authToken');
    if (!token) throw new Error('Not authenticated');
    
    const response = await fetch(getApiUrl(`notifications/${notificationId}/read?userEmail=${encodeURIComponent(userEmail)}`), {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`Failed to mark notification as read: ${response.status}`);
    }
  },

  // Mark all notifications as read for a user
  async markAllAsRead(userEmail: string): Promise<void> {
    const token = localStorage.getItem('authToken');
    if (!token) throw new Error('Not authenticated');
    
    const response = await fetch(getApiUrl('notifications/mark-all-read'), {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userEmail }),
    });
    
    if (!response.ok) {
      throw new Error(`Failed to mark all notifications as read: ${response.status}`);
    }
  },

  // Get unread count for a user
  async getUnreadCount(userEmail: string): Promise<{ unreadCount: number }> {
    const token = localStorage.getItem('authToken');
    if (!token) throw new Error('Not authenticated');
    
    const response = await fetch(getApiUrl(`notifications/unread-count?userEmail=${encodeURIComponent(userEmail)}`), {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`Failed to fetch unread count: ${response.status}`);
    }
    
    return response.json();
  },

  // Remove a notification for a user
  async removeNotification(notificationId: number, userEmail: string): Promise<void> {
    const token = localStorage.getItem('authToken');
    if (!token) throw new Error('Not authenticated');
    const response = await fetch(getApiUrl(`notifications/${notificationId}?userEmail=${encodeURIComponent(userEmail)}`), {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error(`Failed to remove notification: ${response.status}`);
    }
  },

  // Remove all notifications for a user
  async removeAllNotifications(userEmail: string): Promise<void> {
    const token = localStorage.getItem('authToken');
    if (!token) throw new Error('Not authenticated');
    
    const response = await fetch(getApiUrl('notifications/all'), {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userEmail }),
    });
    
    if (!response.ok) {
      throw new Error(`Failed to remove all notifications: ${response.status}`);
    }
  },
};
